<template>
    <div>
        <v-progress-circular :width="2" indeterminate v-if="isTraining" />
        <v-container>
            <v-timeline>
                <div v-for="(message, i) in messages" :key="i">
                    <v-timeline-item :right="!message.fromUser" :left="message.fromUser" v-if="message.answer || message.text || !intentCardComponent(message)">
                        <v-card>
                            <v-card-text>
                                <h2>{{ message.text || message.answer || '** SILENCE **' }}</h2>
                            </v-card-text>
                        </v-card>
                    </v-timeline-item>
                    <v-timeline-item v-if="intentCardComponent(message)" :right="!message.fromUser" :left="message.fromUser">
                        <component :is="intentCardComponent(message)"
                                :message="message"
                                :context="context"
                                :manager="manager" />
                    </v-timeline-item>
                </div>
            </v-timeline>
            <v-progress-linear indeterminate v-if="busyAnswering" color="secondary" />
            <v-form @submit.prevent="submit" class="full-width mt-5" ref="form">
                <v-layout row>
                    <v-textarea class="message-input mt-0 pt-0"
                                placeholder="Type a message (send with CTRL+Enter)"
                                hide-details
                                single-line
                                solo
                                no-resize
                                rows="2"
                                @keyup.ctrl.enter="submit"
                                v-model="line" />
                    <v-btn type="submit"
                        :disabled="busyAnswering || !line"
                        color="success" fab small dark>
                        <v-icon>send</v-icon>
                    </v-btn>
                </v-layout>
            </v-form>
            <v-checkbox
                v-if="textToSpeechAvailable"
                v-model="readAnswersTextToSpeech"
                label="Lees antwoorden voor" />
        </v-container>
    </div>
</template>

<script>
import 'node-nlp/dist/bundle'
import train from './Assistent/train'
import intentCardComponents, { componentName as intentCardComponentName } from './Assistent/IntentCard'

export default {
    components: {
        ...intentCardComponents,
    },
    data () {
        return {
            manager: null,
            context: null,
            messages: [],
            line: 'Wat is Cell[0]?',
            busyAnswering: false,
            readAnswersTextToSpeech: false,
        }
    },
    methods: {
        intentCardComponent (message) {
            return intentCardComponentName(message.intent)
        },
        scrollToBottom () {
            window.scrollTo(0, document.body.scrollHeight)
        },
        async submit () {
            this.messages.push({
                text: this.line,
                fromUser: true,
            })
            const line = this.line
            this.line = ''

            await this.$nextTick()
            this.scrollToBottom()

            this.busyAnswering = true
            try {
                const response = await this.manager.process('nl', line, this.context)
                const delay = 100 + Math.floor(Math.random() * 1000)
                await new Promise((resolve) => setTimeout(resolve, delay))
                this.messages.push(response)
                this.speakOut(response)
            } finally {
                this.busyAnswering = false
            }

            await this.$nextTick()
            this.scrollToBottom()
        },
        async init () {
            const manager = new window.NLPJS.NlpManager({ languages: ['nl'] })
            await train(manager)
            this.manager = manager
            this.context = new window.NLPJS.ConversationContext()
        },
        speakOut (response) {
            if (!this.readAnswersTextToSpeech) {
                return
            }

            if (!response.answer) {
                return
            }

            if (!this.textToSpeechAvailable) {
                return
            }

            const utterance = new SpeechSynthesisUtterance(response.answer)
            const synth = window.speechSynthesis
            utterance.voice = this.textToSpeechVoice
            synth.speak(utterance)
        },
    },
    computed: {
        textToSpeechAvailable () {
            return !!window.speechSynthesis
        },
        textToSpeechVoice () {
            const voices = window.speechSynthesis.getVoices()
            const voice = voices.find((v) => {
                return v.lang.toLowerCase().startsWith('nl_')
            })
            return voice
        },
        isTraining () {
            return this.manager === null
        },
    },
    mounted () {
        this.$nextTick(() => {
            this.init()
        })
    },
}
</script>

<style>
form.full-width {
    width: 100%;
}
.message-input textarea {
    font-size: 1rem;
    line-height: 1rem;
    margin-top: 0.5em !important;
}
</style>
